<ix-modal-header icon="info">{{ activeModal.data?.title }}</ix-modal-header>
<ix-modal-content>
  <p>{{ activeModal.data?.content }}</p>
</ix-modal-content>
<ix-modal-footer>
  <ix-button
    (click)="activeModal.dismiss('dismiss')"
    class="dismiss-modal"
    onkeypress=""
    variant="secondary"
  >
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button (click)="activeModal.close(true)" onkeypress="" variant="primary">
    {{ 'general.ok' | translate }}
  </ix-button>
</ix-modal-footer>
